import React from 'react'

import { LoadingSpinner } from '@frame/ui-components/loading-spinner'

export function Loader() {
  return (
    <div className="relative bottom-[56px] flex h-full w-full items-center justify-center">
      <LoadingSpinner className="h-[48px] w-[48px]" />
    </div>
  )
}
